import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import CreateSRAModal from '../Components/CreateSRAModal'
import MoreSRA from '../Components/MoreSRA'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import PrintSra from '../Components/PrintSra'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { GetAllSRA } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'

export default function StoreReceivedAdvise() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
  const [SraID, setSraID] = useState("");

  const [Data, setData] = useState([]);
  const [TotalData, setTotalData] = useState("");

  const [CurrentPage, setCurrentPage] = useState(1);
  const [ActionType, setActionType] = useState("");
  const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
  const [updateImage, setupdateImage] = useState(false);
  const [PrintMode, setPrintMode] = useState(false);
  const [SingleData, setSingleData] = useState([]);
  const [PreLoader, setPreLoader] = useState(true);


  //get current post

  const indexOfLastSra = CurrentPage * PostperPage;
  const indexOfFirstSra = indexOfLastSra - PostperPage;
  const currentSra = Data.slice(indexOfFirstSra, indexOfLastSra);
  //change page 
  const paginate = (pageNumber) => {
      setCurrentPage(pageNumber)
  }


  const openSra = (id)=>{
    setHandleMoreSRA(true)
  let single =   Data.filter((item)=>{
      return item._id == id
    })

    setSraID(single)
  }
  const EditSra = (id)=>{
    onOpen()
    setActionType("edit")
    let single =   Data.filter((item)=>{
      return item._id == id
    })

    setSraID(single)
  }

  const handleSRA = ()=>{
    setActionType("create")
    onOpen()
  }

  const AllSRA = async () => {
    let result = await GetAllSRA()

    console.log("object sra", result);

    if (result.status == true) {
        setData(result.queryresult.sraiirdetails)
        setTotalData(result.queryresult.totalsraiirdetails)
        setPreLoader(false)
    }
}

const Print = (id)=>{

  let singleInfo = Data.filter((item, i) => {
      return item._id === id
    })
    setPrintMode(true)
    setSingleData(singleInfo)

}

const back = ()=>{
  setPrintMode(false)
}


const [SearchText, setSearchText] = useState("");
useEffect(() => {
  AllSRA()
}, [isOpen,HandleMoreSRA,updateImage]);
  return (
   <>
      {
                PreLoader && (

                    <Preloader/>
                )
            }
    {
      PrintMode ? (
        <PrintSra SingleData={SingleData} onClick={back}/>
      ):(
        <MainLayout>
   <Seo title='Store Received Advice' description='EKO IMS - Store Received Advice'/>

  <Flex justifyContent={"space-between"} flexWrap="wrap" fontWeight={"500"}>
  <HStack onClick={handleSRA} cursor={"pointer"} _hover={{ color: "blue.blue600" }}>
  <Box>
      <AiOutlinePlus />
  </Box>
  <Text >Create SRA</Text>

</HStack>

<Text textTransform="Capitalize" >Total SRA - {TotalData}</Text>
  </Flex>

  <SearchComponent SearchText={SearchText} setSearchText={(e)=>setSearchText(e.target.value)} Keywords={"suppliersId, ItemNumber, InvoiceNumber"} />

  <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{overflow: "auto"}} bg="blue.blue200" mt="32px" rounded={"8px"}>
            
            <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"
     
            >
              <Table variant='simple' size='sm' overflowX="auto" >
                <Thead>
                  <Tr>
                    <Th color="#fff">S/N</Th>
                    <Th color="#fff">Suppliers id</Th>
                    <Th color="#fff">IIR Number</Th>
                    <Th color="#fff">Date received</Th>
                    <Th color="#fff">Invoice Number</Th>
                    <Th color="#fff">Print</Th>
                    <Th color="#fff">Edit</Th>
                    <Th color="#fff">View More</Th> 
                    
                  </Tr>
                </Thead>
                <Tbody>
      
                {
                  SearchText === "" ? (
                    currentSra.map((item,i)=>(
                    <TableRow
                    type="sra"
                    sn={i + 1}
                    supplierName={item.suppliersname}
                    itemNo={item.itemnos}
                    dateReceived={moment(item.datereceived).format('DD/MM/YYYY')}
                    invoiceNo={item.invoicenumber}
                    onClick={()=>openSra(item._id)}
                    print={()=>Print(item._id)}
                    status={item.product[0]?.status}
                    onEdit={()=>EditSra(item._id)}

                   
                    

                    />  
                  ))
                  ):(
                    SearchText !== "" && Data.filter(item => item.itemnos.includes(SearchText) || item.invoicenumber.includes(SearchText) || item.suppliersname.includes(SearchText)).length > 0 ? (
                      DataTransferItem.filter(item => item.itemnos.includes(SearchText) || item.invoicenumber.includes(SearchText) || item.suppliersname.includes(SearchText)).
                      map((item,i)=>(
                    <TableRow
                    type="sra"
                    sn={i + 1}
                    itemNo={item.itemnos}
                    supplierName={item.suppliersname}
                    dateReceived={moment(item.datereceived).format('DD/MM/YYYY')}
                    invoiceNo={item.invoicenumber}
                    onClick={()=>openSra(item._id)}
                    print={()=>Print(item._id)}
                    status={item.product[0]?.status}
                    onEdit={()=>EditSra(item._id)}
                   
                    

                    />
                  ))
                    ):(
                      <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>

                    )

                  )
               
                }

              
                </Tbody>
      
              </Table>
            </TableContainer>
            <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />

            </Box>

<CreateSRAModal isOpen={isOpen} onClose={onClose} actionType={ActionType} singleItem={SraID} />
<MoreSRA isOpen={HandleMoreSRA} onClose={()=>setHandleMoreSRA(false)} setupdateImage={setupdateImage} singleData={SraID}/>
   </MainLayout>
      )
    }
   </>
  )
}
